/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { Drawer, Box, styled, Typography, Divider, IconButton, Button, Stepper, Step, StepLabel } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import Catalog from '../Catalog/catalog';
import { useState } from 'react';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import ProductDetails from './ProductDetails';
import { useEffect } from 'react';
import { apiRequest } from '../../../common/common';
import { LoadingPage } from '../../../common/LoadingPage';
import { useSelector } from 'react-redux';

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));

const steps = ['Select Product', 'Product Details'];

export default function CreatteItem({
    open,
    setOpen,
    templateItem,
    getData
}) {
    const { user } = useSelector(state => state.users);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [item, setItem] = useState({});
    const handleClose = () => {
        setOpen(false);
        setItem(null);
        setActiveStep(0);
        setSelectedProduct([]);
    }
    const handleSubmit = async () => {
        if (item.quantity >= 1) {
            setDataLoading(true);
            try {
                const response = await apiRequest('post', '/template/item', item);
                if (response.data) {
                    handleClose();
                    getData(1, 'personal', templateItem);
                    getData(1, 'public', templateItem);
                    getData(1, 'organization', templateItem);
                    showNotification(response.data.message, 'success');
                }
            } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        } else {
            showNotification('Item quantity should be more than 0', 'error');
        }
    }

    const handleNext = () => {
        if (activeStep === 0 && selectedProduct.length === 0) {
            showNotification('Please select product', 'error');
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    useEffect(() => {
        if (templateItem) {
            setItem((prevData) => ({
                ...prevData,
                dept_template_id: templateItem?.dept_template_id,
                room_template_id: templateItem?.room_template_id,
                status: 'active',
                organization_id: user?.organization?.organization_id,
                created_by: user?.user_id,
                quantity: 1,
            }));
        }
        if (selectedProduct?.length > 0) {
            setItem((prevData) => {
                const selectedProductData = selectedProduct[0];
                const filteredProductData = Object.keys(selectedProductData).reduce((acc, key) => {
                    if (selectedProductData[key] != null) {
                        acc[key] = selectedProductData[key];
                    }
                    return acc;
                }, {});

                return {
                    ...prevData,
                    item_name: filteredProductData?.model,
                    furnish_responsibility: filteredProductData?.furnish_responsibility,
                    install_responsibility: filteredProductData?.install_responsibility,
                    architectural_code: filteredProductData?.architectural_code,
                    vendor_id: filteredProductData?.vendor_id,
                    product_id: filteredProductData?.product_id,                    
                    list_price: filteredProductData?.list_price,
                };
            });

        }
    }, [templateItem, selectedProduct]);

    return (
        <Drawer
            anchor="bottom"
            open={open}
            sx={{
                '& .MuiDrawer-paper': {
                    height: '85%',
                }
            }}
        >
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DemoBox1>
                <Typography variant='body1' style={{ fontWeight: 'bold' }}>Add Product To Template</Typography>
                <Box>
                    {activeStep > 0 && (
                        <Button variant='outlined' size="small" onClick={() => handleBack()} style={{ marginRight: 5 }}>
                            Back
                        </Button>
                    )}
                    {activeStep < 1 && (
                        <Button variant='contained' size="small" onClick={() => handleNext()}>
                            Next
                        </Button>
                    )}
                    {activeStep === 1 && (
                        <Button variant='contained' size="small" onClick={() => handleSubmit()}>
                            Save
                        </Button>
                    )}
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            </DemoBox1>
            <Divider />
            <Box sx={{ width: '100%', padding: '10px' }}>
                <Stepper activeStep={activeStep} style={{ marginBottom: '5px' }}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <Divider />
            </Box>
            {activeStep === 0 && (
                <Catalog
                    fromTemplate={true}
                    setSelectedProduct={setSelectedProduct}
                />
            )}
            {activeStep === 1 && (
                <ProductDetails
                    selectedProduct={selectedProduct}
                    item={item}
                    setItem={setItem}
                    templateItem={templateItem}
                />
            )}
        </Drawer>
    );
}